import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as React from "react";

export interface PoshSelectListItem {
    id: string;
    title: string;
    description?: string;
    icon: IconProp;
    isChecked: boolean;
    onChange: (checked: boolean) => void;
}

export const PoshSelectCheckboxListItem = ({ id, title, description, icon, onChange, isChecked }: PoshSelectListItem) => {
    return (
        <li>
            <input id={id} type="checkbox" name="action" value={id} checked={isChecked} onChange={(e) => onChange(e.target.checked)} />
            <label htmlFor={id}>
                <span className="posh-select-icon">
                    <FontAwesomeIcon icon={icon} aria-hidden="true" />
                </span>
                <span className="posh-select-body">
                    <span className="posh-select-title">{title}</span>
                    {description ? <span className="posh-select-description text-muted">{description}</span> : null}
                </span>
            </label>
        </li>
    );
}

export const PoshSelectRadioListItem = ({ id, title, description, icon, onChange, isChecked }: PoshSelectListItem) => {
    return (
        <li>
            <input id={id} type="radio" name="action" value={id} checked={isChecked} onChange={(e) => onChange(e.target.checked)} />
            <label htmlFor={id}>
                <span className="posh-select-icon">
                    <FontAwesomeIcon icon={icon} aria-hidden="true" />
                </span>
                <span className="posh-select-body">
                    <span className="posh-select-title">{title}</span>
                    {description ? <span className="posh-select-description text-muted">{description}</span> : null}
                </span>
            </label>
        </li>
    );
}
